module.exports = "http://cdn.realive.com.ua/src/views/donate/sapper/images/logo-sapper.png";